<template>
  <div :class="['t-input-action']">
    <div :class="['t-input-text']">
      <input
        :type="type"
        :min="min"
        :max="max"
        autocapitalize="off"
        ref="input"
        v-bind="$attrs"
        :value="model"
        @input="handleInput"
      />
      <button
        v-show="model.length"
        class="t-input-clear"
        aria-label="Clear Text Input"
        type="button"
        @click="
          $emit('reset')
          focus()
        "
      >
        <span class="icon-close"></span>
      </button>
    </div>
    <div :class="[baseClass, btnClass]">
      <button
        v-if="btn"
        type="submit"
        :class="['t-button', {'t-disabled': disabled || !valid}]"
        :disabled="disabled || !valid"
      >
        <span> {{ btnLabel }} </span>
      </button>
    </div>
  </div>
</template>

<script>
import BaseMixin from './BaseMixin.vue'

export default {
  name: 'InputText',

  mixins: [BaseMixin],

  inheritAttrs: false,

  props: {
    type: {
      type: String,
      default: 'text',
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    value: {
      default: '',
    },
    btn: {
      type: String,
      default: null,
      validator: v => v === 'go',
    },
  },

  data() {
    let btnLabel,
      btnClass,
      btnType = 'button'
    if (this.btn === 'go') {
      btnLabel = 'go'
      btnClass = 't-button-go'
      btnType = 'submit'
    }
    return {
      btnLabel,
      btnClass,
      btnType,
    }
  },

  computed: {
    model: {
      get() {
        return this.value.trim()
      },
      set(v) {
        if (v !== this.value) {
          this.$emit('input', v)
        }
      },
    },

    valid() {
      if (this.type === 'number') {
        return (
          (this.min === null || this.value >= this.min) &&
          (this.max === null || this.value <= this.max)
        )
      }
      return this.value !== ''
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus()
    },

    blur() {
      this.$refs.input.blur()
    },

    handleInput() {
      // v-model has an internal flag needCompositionGuard which
      // prevents updating the value while the mobile keyboard is
      // completing words. The effect is that the user has to press
      // enter once to accept the word suggestion, then press enter
      // again to submit the form. It seems like a bug, but I haven't
      // asked upstream yet. By listening directly for input,
      // effectively going around v-model's needCompositionGuard, we
      // get updates immediately.
      this.model = this.$refs.input.value.trim()
    },
  },
}
</script>
